<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <header-list
                    :title="pageTitle"
                    :placeholderSearch="searchPlaceholder"
                    v-model="query"
                    :routeAddName="`${moduleCode}.${pageID}.create`"
                    :routeAddParams="{ type: 'item' }"
                    :canAdd="canAdd"
                    :addTitle="addItemTitle"
                    :icon="icon"
                    @search="onSearch">
                    <template v-slot:buttons-right v-if="canAdd">
                        <router-link
                            v-html="addGroup"
                            class="btn btn-main btn-rounded btn-sm min-w-auto my-0 px-3 d-flex flex-row align-items-center justify-content-center flex-nowrap d-sm-inline"
                            :to="{ name: `${moduleCode}.${pageID}.create`, params: { type: 'group' } }">
                        </router-link>
                    </template>
                </header-list>

                <div class="row">
                    <div class="col">
                        <div id="accordion">
                            <div class="card accordion" v-for="(item, idx) in list" :key="`card-${idx}`" v-if="item[columnParentId] == null">
                                <div class="card-header">
                                    <div class="row no-gutters">
                                        <div
                                            class="col d-flex justify-content-between"
                                            :class="{'tbl-column-disabled': !item.status}"
                                            :id="'heading'+item.id"
                                            data-toggle="collapse"
                                            :data-target="'#collapse'+item.id"
                                            :aria-expanded="idx==0 && numGroups==1"
                                            :aria-controls="'collapse'+item.id">
                                            <span>{{item.name}}</span>
                                        </div>
                                        <column-actions
                                            v-if="checkActions"
                                            tag="div"
                                            class="col-auto d-flex justify-content-end"
                                            listClass="actions"
                                            :routeEdit="`${moduleInternalCode}.${pageID}.show.${routeGroupKey}`"
                                            @delete="deleteItem"
                                            deleteMsgTemplate="global.msg.confirm.delete-group"
                                            :canDetail="canDetail"
                                            :canEdit="canEdit"
                                            :canDelete="canDelete"
                                            :row="item"
                                            :index="idx"
                                            :callbackDelete="onRemove" />
                                    </div>
                                </div>
                                <div
                                    :id="'collapse'+item.id"
                                    class="collapse"
                                    :class="{'show': idx==0 && numGroups==1}"
                                    :aria-labelledby="'heading'+item.id"
                                    data-parent="#accordion">

                                    <div class="card-body">
                                        <table-data
                                            :showTitleData="false"
                                            :data="item[columnChildrens]"
                                            tableWrapperClass="table-responsive"
                                            :settings="table.settings"
                                            :columns="tableColumns"
                                            :inlineFilters="table.filters"
                                            :autoUpdateFilter="table.autoUpdateFilter"
                                            :addParamsToUrl="table.addParamsToUrl"
                                            :loadingMsg="table.loadingMsg"
                                            :notFoundMsg="table.notFoundMsg"
                                            :orderByTemplate="table.orderByTemplate"
                                            :showPagination="table.showPagination"
                                            :tableInline="table.tableInline"
                                            @error-load="showError"
                                        >
                                            <template v-slot:body="{row, index, remove}">
                                                <td :class="[tableColumns[0].class, {'tbl-column-disabled': !row.status}]">
                                                    {{row[tableColumns[0].field]}}
                                                </td>
                                                <column-actions v-if="checkActions"
                                                    :routeEdit="`${moduleInternalCode}.${pageID}.show.${routeItemKey}`"
                                                    @delete="deleteItem"
                                                    :canDetail="canDetail"
                                                    :canEdit="canEdit"
                                                    :canDelete="canDelete"
                                                    :row="row"
                                                    :index="index"
                                                    :callbackDelete="remove" />
                                            </template>
                                        </table-data>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import GeneralMixin from './mixins/GeneralMixin'

export default {
    name: 'RegulationList',
    mixins: [
        GeneralMixin
    ],
    props: {
        id: {
            type: String,
            required: true,
        },
        columnParentId: {
            type: String,
            default: 'parent_id',
        },
        columnChildrens: {
            type: String,
            default: 'children',
        },
        addItemTitle: {
            type: String,
            default: 'global.add',
        },
        routeGroupKey: {
            type: String,
            default: 'group',
        },
        routeItemKey: {
            type: String,
            default: 'item',
        }
    },
    data() {
        return {
            pageID: null,
            pageTitle: 'List',
            table: {
                showPagination: false,
                tableInline: true,
            },
        }
    },
    beforeMount() {
        this.pageID = this.id;
    },
    computed: {
        addGroup() {
            return `<i class="fas fa-plus"></i> ${this.$t('global.group')}`
        },
        icon() {
            return 'fas fa-plus'
        },
        numGroups() {
            return this.list.filter( item => item[this.columnParentId]==null).length;
        },
        tableColumns() {
            return [
                {
                    label: `${this.pageID}.model.name`,
                    field:  'name',
                    sortable: false,
                },
                {
                    label: '',
                    field:  null,
                    sortable: false,
                    class: 'actions',
                }
            ];
        },
    },
    methods: {
        onRemove: function(id, data){
            this.loadData();
        },
    }
}
</script>

<style>

</style>